import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialog,
} from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PositionMainDutiesComponent } from '../position-main-duties/position-main-duties.component';

@Component({
  selector: 'app-occupation-details',
  templateUrl: './occupation-details.component.html',
  styleUrls: ['./occupation-details.component.scss']
})
export class OccupationDetailsComponent implements OnInit {
  RESOURCE_SERVER_URL = environment.RESOURCE_SERVER_URL;
  openIcon = this.RESOURCE_SERVER_URL + '/assets/images/open_1.svg';

  claimId: any;
  isLoading: boolean = false;
  occupationUrl: any;
  occupationModule: any;

  constructor(
    private commonService: CommonService,
    public dialog: MatDialog,
    private dialogRef: MatDialogRef<OccupationDetailsComponent>,
    private route: ActivatedRoute,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data
  ) { }

  async ngOnInit() {
    this.claimId = this.data.claimID;
    this.occupationUrl = this.data.occupationUrl;
    console.log('occupationUrl', this.occupationUrl);
    await this.getOccupationById();
  }

  async onCloseDialog() {
    this.dialogRef.close();
  }
  
  async onChangeValue(event, key) {
    this.occupationModule[key] = event;
  }

  async getOccupationById() {
    this.isLoading = true;
    try {
      let url = this.occupationUrl;
      let getOccupationResponse = await this.commonService.commonGet(url);
      this.occupationModule = getOccupationResponse.body;
      this.isLoading = false;
    } catch (error) {
      console.log('Get Claim disability By Id Failed', error);
      this.isLoading = false;
    }
  }

  openDutiesBeforeDisability() {
    const RefDialog = this.dialog.open(PositionMainDutiesComponent, {
      width: '40%',
      height: 'auto',
      data: {
        // sending data into Dialog
        claimId: this.claimId,
        positionBeforeDisability:
          this.occupationModule['positionBeforeDisability'],
        positionBeforeDisabilityFlag: true,
      },
    });
    RefDialog.afterClosed().subscribe(async (result) => {
      console.log('Share Dialog Was Closed');
    });
  }

  openDutiesAfetrDisability() {
    const RefDialog = this.dialog.open(PositionMainDutiesComponent, {
      width: '40%',
      height: 'auto',
      data: {
        // sending data into Dialog
        claimId: this.claimId,
        positionAfterDisability:
          this.occupationModule['positionAfterDisability'],
        positionAfterDisabilityFlag: true,
      },
    });
    RefDialog.afterClosed().subscribe(async (result) => {
      console.log('Share Dialog Was Closed');
    });
  }

}
